/**
 * Dimension key for the end user a call was made on behalf of, as exposed by the MGW
 * `api_usage_insights` dataset.
 *
 * Deliberately generic rather than MCP-specific: this is the API usage dashboard, and
 * the dimension is a property of API traffic. MCP-over-SSO-OAuth is currently the only
 * thing that populates it, but nothing about the dimension is MCP-only.
 *
 * Not to be confused with `options.username` on the same request, which is the Pulse
 * user *viewing* the dashboard.
 *
 * See public-mcp-core-service/docs/MCP_PER_USER_USAGE_ATTRIBUTION.md, link 5.
 */
export const USER_NAME_DIMENSION = 'USER_NAME';

export const BREAKDOWN_DIMENSIONS = [
  { key: 'CLIENT_NAME', label: 'Client Name' },
  { key: 'API_CLIENT_ID', label: 'API Client ID' },
  { key: 'CUSTOMER_NAME', label: 'Customer Name' },
] as const;

/**
 * Appended to {@link BREAKDOWN_DIMENSIONS} only when the `show-user-name-breakdown`
 * feature flag is on. Kept separate because the underlying dimension does not exist
 * in MGW until link 5 ships — querying it before then returns an error, which would
 * render as a permanently broken table.
 */
export const USER_NAME_BREAKDOWN_DIMENSION = {
  key: USER_NAME_DIMENSION,
  label: 'User Name',
} as const;

/** Every dimension we know about, flag or no flag. Use for label lookups. */
export const ALL_BREAKDOWN_DIMENSIONS = [
  ...BREAKDOWN_DIMENSIONS,
  USER_NAME_BREAKDOWN_DIMENSION,
] as const;

/** The dimensions to actually render, given the feature flag. */
export const getBreakdownDimensions = (showUserName: boolean) =>
  showUserName ? ALL_BREAKDOWN_DIMENSIONS : BREAKDOWN_DIMENSIONS;

export const BREAKDOWN_METRICS = ['RealtimeAPICalls', 'HistoricalAPICalls'] as const;

export const API_BREAKDOWN_TIMESERIES_KEY = 'api-usage-breakdown-timeseries';
export const API_BREAKDOWN_GROUPBY_KEY = 'api-usage-breakdown-groupby';

export const USAGE_TYPE_ALL = 'all' as const;
export const USAGE_TYPE_MCP_ONLY = 'mcp-only' as const;
export const USAGE_TYPE_API_ONLY = 'api-only' as const;
